import React, { useEffect, useState } from "react";
import {
    Modal,
    Form,
    Row,
    Col,
    Overlay,
    Popover,
    Button,
} from "react-bootstrap";
import ReactSelect from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import toast from "react-hot-toast";
import Flatpickr from "react-flatpickr";
import axios from "../../API/axios";
import moment from "moment";
import { useParams } from "react-router-dom";
// import "flatpickr/dist/themes/material_blue.css"; // Flatpickr Theme
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";

const AddProject = ({
    showAddProject,
    handleCloseAddProject,
    userDataId,
    getUserCv,
}) => {
    const sessionId = localStorage.getItem("sessionId");
    const userType = localStorage.getItem("userType");
    const { CandidateId } = useParams();

    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [associatedWith, setAssociatedWith] = useState("");
    const [projectUrl, setProjectUrl] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [display, setDisplay] = useState(false);

    const [formChanged, setFormChanged] = useState(false); // Track if form is modified
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formValid, setFormValid] = useState(false); // Track overall form validity

    // Handle changes and mark form as modified
    const handleFieldChange = (setter, value, fieldName) => {
        setter(value);

        // Updated field values ko store karein
        const updatedName = fieldName === "name" ? value : name;
        const updatedStartDate = fieldName === "startDate" ? value : startDate;
        const updatedIsPresent = fieldName === "isPresent" ? value : isPresent;
        const updatedEnddate = fieldName === "endDate" ? value : endDate;

        // Form Validity Check: Ensure all required fields are filled
        const isFormValid =
            updatedName.trim() !== "" &&
            updatedStartDate &&
            (updatedIsPresent || updatedEnddate);
        // &&
        // updatedEndDate &&
        // new Date(updatedEndDate) >= new Date(updatedStartDate); // End Date >= Start Date ka check

        setFormValid(isFormValid);
    };

    // ......................................
    const [isPresent, setIsPresent] = useState(false);

    // const handleCheckboxChange = (e) => {
    //     setIsPresent(e.target.checked);
    //     if (e.target.checked) {
    //         setEndDate(null); // Clear end date when "Is Present" is checked
    //     }
    // };

    // .............................................................

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setDisplay(true);
    //     setIsSubmitting(true); // Disable the button during submission

    //     if (!isPresent && !endDate) {
    //         toast.error("End Date is required if 'Is Present' is not checked");
    //         setIsSubmitting(false);
    //         return;
    //     }

    //     if (!formValid) {
    //         toast.error("Please fill all the required fields");
    //         setIsSubmitting(false); // Re-enable button if validation fails
    //         return;
    //     }

    //     const body = {
    //         sessionId: sessionId,
    //         userDataId: userDataId,
    //         userType: userType,
    //         instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
    //         name: name,
    //         description: description,
    //         associatedWith: associatedWith,
    //         projectUrl: projectUrl,
    //         startMonth: startDate === "" ? "" : moment(startDate).format("MM"),
    //         startYear: startDate === "" ? "" : moment(startDate).format("YYYY"),
    //         // endMonth: endDate === "" ? "" : moment(endDate).format("MM"),
    //         // endYear: endDate === "" ? "" : moment(endDate).format("YYYY"),
    //         endMonth: endDate ? moment(endDate).format("MM") : null,
    //         endYear: endDate ? moment(endDate).format("YYYY") : null,
    //     };
    //     console.log("body", body);

    //     if (name === '' || startDate === '') {
    //         toast.error('Please fill all the required fields')
    //         setIsSubmitting(false); // Re-enable the button if validation fails
    //     } else {
    //         try {
    //             const res = await axios.post("/Resume/AddProject", body);
    //             toast.success(res.data.message);
    //             resetForm();
    //         } catch (error) {
    //             if (error.response && error.response.status === 404) {
    //                 toast.error(error.response.data.message);
    //             } else {
    //                 toast.error(error.response?.data?.message);
    //             }
    //         } finally {
    //             setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
    //         }
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setDisplay(true);
        setIsSubmitting(true); // Disable the button during submission

        // 🔍 Field-level validation
        if (
            name === "" ||
            startDate === "" ||
            (!isPresent && endDate === "") // Require endDate only if 'isPresent' is false
        ) {
            toast.error("Please fill all the required fields");
            setIsSubmitting(false);
            return;
        }

        const body = {
            sessionId: sessionId,
            userDataId: userDataId,
            userType: userType,
            instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
            name: name,
            description: description,
            associatedWith: associatedWith,
            projectUrl: projectUrl,
            startMonth: moment(startDate).format("MM"),
            startYear: moment(startDate).format("YYYY"),
            endMonth: isPresent ? null : (endDate ? moment(endDate).format("MM") : null),
            endYear: isPresent ? null : (endDate ? moment(endDate).format("YYYY") : null),
        };

        console.log("body", body);

        try {
            const res = await axios.post("/Resume/AddProject", body);
            toast.success(res.data.message);
            resetForm();
        } catch (error) {
            if (error.response && error.response.status === 404) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.response?.data?.message || "An error occurred");
            }
        } finally {
            setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
        }
    };


    const resetForm = () => {
        handleCloseAddProject();
        getUserCv();
        setName("");
        setDescription("");
        setAssociatedWith("");
        setProjectUrl("");
        setStartDate(null);
        setEndDate(null);
        setDisplay(false);
        setIsPresent(null);
        setFormValid(false)
        // setFormChanged(false); // Disable the button after update
    };

    const handleCloseProjectFn = () => {
        resetForm(); // Call resetForm when closing the modal
        handleCloseAddProject();
    };
    return (
        <>
            <div className="add-project-modal">
                <Modal
                    show={showAddProject}
                    onHide={handleCloseProjectFn}
                    centered
                    size="lg"
                >
                    <Modal.Header>
                        <Modal.Title>Add project</Modal.Title>
                        <CloseSharpIcon className="pointer" onClick={handleCloseProjectFn} />
                    </Modal.Header>
                    <Modal.Body className="settings">

                        <Row>
                            {/* Skills Section */}
                            <Col md={6} className="mb-2">
                                <Form.Group controlId="field">
                                    <Form.Label className="class-type">
                                        Name <span style={{ color: "red" }}>*</span>
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="Dark-Input-from-group"
                                        value={name}
                                        // onChange={(e) => setName(e.target.value)}
                                        // onChange={(e) => handleFieldChange(setName, e.target.value)} // Track changes
                                        onChange={(e) => handleFieldChange(setName, e.target.value, "name")}
                                        onPaste={(e) => handleFieldChange(setName, e.clipboardData.getData(""), "name")}
                                        placeholder="Enter name"
                                    />
                                    {display && !name ? (
                                        <span className="error_msg_lbl">Add project name </span>
                                    ) : null}
                                </Form.Group>
                            </Col>

                            <Col md={6} className="mb-2">
                                <Form.Group controlId="field">
                                    <Form.Label className="class-type">
                                        Associated with
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="Dark-Input-from-group"
                                        value={associatedWith}
                                        // onChange={(e) => setAssociatedWith(e.target.value)}
                                        onChange={(e) => handleFieldChange(setAssociatedWith, e.target.value)} // Track changes
                                        placeholder="Enter  associated with"
                                    />
                                </Form.Group>
                            </Col>



                            <Col md={6} className="mb-2">
                                <Form.Group controlId="startYear" className="Flatpickr-Calender-Class Flatpickr-Calender-Class-nt">
                                    <Form.Label className="class-type col-md-12">
                                        Start date <span style={{ color: "red" }}>*</span>
                                    </Form.Label>
                                    <Flatpickr
                                        type="number"
                                        value={startDate}
                                        className="Dark-Input-from-group"
                                        onChange={(date) => handleFieldChange(setStartDate, date[0], "startDate")}
                                        placeholder="Enter start year"
                                        options={{
                                            dateFormat: "F Y",
                                            maxDate: new Date(),
                                            static: true,
                                            plugins: [new monthSelectPlugin({
                                                shorthand: false,
                                                dateFormat: "F Y",
                                                altFormat: "F Y"
                                            })],
                                        }}
                                    />
                                    {display && !startDate ? (
                                        <span className="error_msg_lbl">Select start date</span>
                                    ) : null}
                                </Form.Group>
                            </Col>

                            {/* Checkbox for Is Present */}
                            <Col md={6} className="mb-2">
                                <div className="mt-4">
                                    <Form.Check
                                        type="checkbox"
                                        label="Is Present"
                                        checked={isPresent}
                                        // onChange={handleCheckboxChange}
                                        onChange={(e) => handleFieldChange(setIsPresent, e.target.checked, "isPresent")}


                                    />
                                </div>
                            </Col>

                            {/* Conditionally render End Date */}
                            {!isPresent && (
                                <Col md={6} className="mb-2">
                                    <Form.Group controlId="endYear" className="Flatpickr-Calender-Class Flatpickr-Calender-Class-nt">
                                        <Form.Label className="class-type col-md-12">End date <span style={{ color: "red" }}>*</span></Form.Label>
                                        <Flatpickr
                                            type="number"
                                            value={endDate}
                                            className="Dark-Input-from-group"
                                            onChange={(date) => handleFieldChange(setEndDate, date[0], "endDate")}
                                            placeholder="Enter end year"
                                            options={{
                                                dateFormat: "F Y",
                                                maxDate: new Date(),
                                                static: true,
                                                plugins: [new monthSelectPlugin({
                                                    shorthand: false,
                                                    dateFormat: "F Y",
                                                    altFormat: "F Y"
                                                })],
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            )}


                            <Col md={12} className="mb-2">
                                <Form.Group controlId="field">
                                    <Form.Label className="class-type">
                                        Project url
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        className="Dark-Input-from-group"
                                        value={projectUrl}
                                        // onChange={(e) => setProjectUrl(e.target.value)}
                                        onChange={(e) => setProjectUrl(e.target.value)} // Track changes
                                        placeholder="Enter project url"
                                    />
                                    {/* {display && !projectUrl ? (
                                    <span className="error_msg_lbl">Add Project Url </span>
                                ) : null} */}
                                </Form.Group>
                            </Col>
                            <Col md={12} className="mb-2">
                                <Form.Group controlId="field">
                                    <Form.Label className="class-type">
                                        Description
                                    </Form.Label>
                                    <textarea
                                        type="text"
                                        className="Dark-Input-from-group"
                                        value={description}
                                        // onChange={(e) => setDescription(e.target.value)}
                                        onChange={(e) => handleFieldChange(setDescription, e.target.value)} // Track changes
                                        placeholder="Enter description"
                                    />
                                </Form.Group>
                            </Col>

                        </Row>

                        {/* Submit Button */}
                        <div className="add-class-submit-button mt-4 d-flex justify-content-center">
                            <div className="khojPrimaryBtn ms-3"
                                // onClick={formValid && !isSubmitting ? handleSubmit : (e) => e.preventDefault()}
                                onClick={handleSubmit}
                                style={{ cursor: formChanged ? "pointer" : "default" }}
                            >
                                <a
                                    href="#/"
                                    // onClick={formValid && !isSubmitting ? handleSubmit : (e) => e.preventDefault()}
                                    className={`btn ${!formValid || isSubmitting ? "disabled" : "enabled"}`}
                                    
                                    disabled={!formValid || isSubmitting}
                                    style={{
                                        pointerEvents: formValid ? "auto" : "none",
                                        border: "none",
                                    }}
                                >

                                    Submit
                                </a>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>

        </>
    );
};

export default AddProject;
